import dayjs from "dayjs";
import {
  fonts,
  headerMonthHeight,
  headerMonthHeightNew,
  monthsInYear,
  monthWidth,
} from "../../../constants";
import { Day } from "../../../types/global";
// import { getDaysInMonths } from "../../dates";
import { Theme } from "../../../styles";
import { drawRow } from "../../drawRow";

export const drawMonthsOnBottom = (
  ctx: CanvasRenderingContext2D,
  cols: number,
  startDate: Day,
  theme: Theme
) => {
  let xPos = -(startDate.dayOfMonth-1) * 4;
  const yPos = headerMonthHeight;
  const monthIndex = startDate.month;
  let index = monthIndex;
  
  for (let i = 0; i < cols+1; i++) { //+1 por causa do startDate que pega o mes anterior
    if (index >= monthsInYear) index = 0;
    const width = monthWidth;

    drawRow(
      {
        ctx,
        x: xPos,
        y: yPos,
        width,
        height: headerMonthHeightNew,
        textYPos: 50,
        label: dayjs().month(index).format("MMMM").toUpperCase(),
        font: fonts.bottomRow.name
      },
      theme
    );
    xPos += width;
    index++;
  }
};
